var _path, _g, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1854_658",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 16,
    width: 20,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.1201H19.7999V25.3376H0V16.1201Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1854_658)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90113 17.9951C4.57488 17.9951 1.87488 18.9101 1.87488 20.7164C1.87488 22.5389 4.57488 23.4626 9.90113 23.4626C15.2261 23.4626 17.9249 22.5476 17.9249 20.7414C17.9249 18.9189 15.2261 17.9951 9.90113 17.9951ZM9.90113 25.3376C7.45238 25.3376 -0.00012207 25.3376 -0.00012207 20.7164C-0.00012207 16.5964 5.65113 16.1201 9.90113 16.1201C12.3499 16.1201 19.7999 16.1201 19.7999 20.7414C19.7999 24.8614 14.1499 25.3376 9.90113 25.3376Z",
    fill: "#BDBDBD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1854_658",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26233 0.5H16.5374V13.7732H3.26233V0.5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1854_658)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90112 2.28402C7.22487 2.28402 5.04737 4.46027 5.04737 7.13652C5.03862 9.80402 7.19987 11.979 9.86487 11.989L9.90112 12.8815V11.989C12.5761 11.989 14.7524 9.81152 14.7524 7.13652C14.7524 4.46027 12.5761 2.28402 9.90112 2.28402ZM9.90112 13.7728H9.86112C6.20862 13.7615 3.24987 10.7828 3.26237 7.13277C3.26237 3.47652 6.23987 0.499023 9.90112 0.499023C13.5611 0.499023 16.5374 3.47652 16.5374 7.13652C16.5374 10.7965 13.5611 13.7728 9.90112 13.7728Z",
    fill: "#BDBDBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2);
export default __webpack_public_path__ + "static/media/profile2.ce68bd0770285af63f602b33a363986c.svg";
export { ForwardRef as ReactComponent };